import React from "react";
import BackgroundImage from 'gatsby-background-image'
import { graphql, useStaticQuery } from 'gatsby';
import withStyles from "@material-ui/core/styles/withStyles";

function RunningAcrossBridge({...props}) {
  const {
    className,
    imageUrl,
    children,
    style
  } = props;
  const data = useStaticQuery(
    graphql`
      query {
        desktop: file(relativePath: { eq: "running-across-bridge.jpg" }) {
          childImageSharp {
            fluid(quality: 50, maxWidth: 960) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );

  // Set ImageData.
  const imageData = data.desktop.childImageSharp.fluid;

  return (
    <BackgroundImage 
    Tag="div"
    role="img"
    aria-label="Seen from behind, a person running across a footbridge from one mountain peak to another."
    className={className}
    fluid={imageData}
    style={style}
    >
      {children}
    </BackgroundImage>
  )
};

const styles = {
  width: "100%",
  backgroundPosition: "bottom center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover"
};

export default withStyles(styles)(RunningAcrossBridge);